import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step14View from './Step14-view';
import {checkRequiredValues} from '../../utils/forms/checkRequiredValues';
import {fileTypesIds} from '../../constants/fileTypeIds';
import {getFileFromDataURI} from '../../utils/files/getFileFromDataURI';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const Step14 = ({
                  submitStep,
                  uploadFile,
                  regType,
                  prevCompletedStepSign,
                  prevCompletedStepSignFalse,
                }) => {
  const initialValues = {
    signature: null,
  };

  const validate = values => {
    let errors = {};
    errors = checkRequiredValues(values, errors);

    return errors;
  };

  const {formatMessage} = useIntl();

  const handleSubmit = values => {
    Promise.resolve()
      .then(() => submitFiles(values))
      .then(() => submitFields())
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
          {
            step_number: 14,
            step_name_en: 'Income tax',
            step_name_he: formatMessage({id: 'step14.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.log({err}))
  };

  const submitFields = () => {
    return submitStep({
      step: 14,
      data: {regType, prevCompletedStepSign},
    })
  };

  const submitFiles = values => {
    return getFileFromDataURI({dataURI: values.signature, filename: 'signature-form101.png'})
      .then(file => uploadFile({
        file,
        fileTypeId: fileTypesIds.step14.signature
      }));
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({isValid, submitCount}) => (
        <Step14View
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step14.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  submitStep: PropTypes.func,
  uploadFiles: PropTypes.func
};

export default Step14;
